'use strict';

var BackToMainService = function ($state, SettingsConstants) {
    return {
        backToMain: function () {
            if (window.params && window.params.length > 0) {
                window.location.href = contentPath;
            } else {
                $state.go(SettingsConstants.APP_DEFAULT_STATE)
            }
        }
    };
};

BackToMainService.$inject = ['$state', 'SettingsConstants'];

module.exports = BackToMainService;